/**
 * Local Microsoft Graph capability → scope mapping (Mail / Drive / Teams).
 * Align with the canonical contract in the monorepo when changing scopes.
 */

export const MICROSOFT_GRAPH_CAPABILITY = {
  MAIL: 'mail',
  DRIVE: 'drive',
  TEAMS: 'teams',
};

const SCOPES_BY_CAPABILITY = {
  [MICROSOFT_GRAPH_CAPABILITY.MAIL]: ['Mail.Read', 'Mail.Send'],
  [MICROSOFT_GRAPH_CAPABILITY.DRIVE]: ['Files.ReadWrite.All'],
  [MICROSOFT_GRAPH_CAPABILITY.TEAMS]: [
    'Team.ReadBasic.All',
    'Channel.ReadBasic.All',
    'Chat.ReadBasic',
    'ChannelMessage.Send',
    'Chat.ReadWrite',
  ],
};

const BASELINE = [
  MICROSOFT_GRAPH_CAPABILITY.MAIL,
  MICROSOFT_GRAPH_CAPABILITY.DRIVE,
];

export function scopesForCapabilities(capabilities) {
  const set = new Set();
  for (const cap of capabilities) {
    const list = SCOPES_BY_CAPABILITY[cap] || [];
    for (const s of list) {
      set.add(s);
    }
  }
  set.add('offline_access');
  return [...set];
}

export function normalizeCapabilities(selected) {
  if (!Array.isArray(selected) || selected.length === 0) {
    return [...BASELINE];
  }
  const allowed = new Set(Object.values(MICROSOFT_GRAPH_CAPABILITY));
  const out = selected.filter((x) => typeof x === 'string' && allowed.has(x));
  return out.length ? out : [...BASELINE];
}
